/**
 * ResumeCard — Algomed HomeHubPage'deki "Kaldigin yerden devam" widget'inin
 * Mini App muadili. Sadece localStorage'da en son ziyaret edilen modül varsa
 * görünür. Tasarim: accent-bordered Flex, sol ikon kutusu, sağ CTA butonu.
 *
 * Kaynak desen: HomeHubPage.jsx > readLatestResume + resumeTarget JSX bloğu.
 */
import { Box, Button, Flex, HStack, Text, VStack } from '@chakra-ui/react';
import { haptic } from '../telegram';

export interface ResumeCardProps {
  /** Üst rozet (ör. "KALDIĞIN YERDEN DEVAM"). */
  eyebrow: string;
  title: string;
  context?: string | null;
  glyph: string;
  ctaLabel: string;
  onResume: () => void;
  onDismiss?: () => void;
}

export default function ResumeCard({
  eyebrow,
  title,
  context,
  glyph,
  ctaLabel,
  onResume,
  onDismiss,
}: ResumeCardProps) {
  return (
    <Flex
      bg="headerBg"
      borderWidth="1px"
      borderColor="accent"
      borderRadius="xl"
      boxShadow="cardElevated"
      px={3}
      py={2.5}
      align="center"
      gap={2.5}
    >
      <Flex
        w="36px"
        h="36px"
        borderRadius="lg"
        bg="accent"
        align="center"
        justify="center"
        flexShrink={0}
        color="white"
      >
        <Text fontSize="lg" lineHeight="1" fontWeight="bold">
          {glyph}
        </Text>
      </Flex>
      <VStack align="start" spacing={0} flex="1" minW={0}>
        <Text
          color="textMuted"
          fontSize="10px"
          fontWeight="semibold"
          textTransform="uppercase"
          letterSpacing="0.05em"
          noOfLines={1}
        >
          {eyebrow}
        </Text>
        <Text color="textPrimary" fontSize="sm" fontWeight="bold" noOfLines={1}>
          {title}
        </Text>
        {context ? (
          <Text color="textSecondary" fontSize="11px" noOfLines={1}>
            {context}
          </Text>
        ) : null}
      </VStack>
      <HStack spacing={1} flexShrink={0}>
        <Button
          size="xs"
          colorScheme="brand"
          onClick={() => {
            haptic('select');
            onResume();
          }}
        >
          {ctaLabel}
        </Button>
        {onDismiss ? (
          <Button
            size="xs"
            variant="ghost"
            aria-label="Kapat"
            onClick={() => {
              haptic('select');
              onDismiss();
            }}
            px={1.5}
          >
            <Box as="span" fontSize="md" lineHeight="1">×</Box>
          </Button>
        ) : null}
      </HStack>
    </Flex>
  );
}
